import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

export type AssignmentTableHeaderProps = {
  headers: string[];
};

export const AssignmentTableHeader = ({
  headers,
}: AssignmentTableHeaderProps) => {
  const { t } = useTranslation();
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="border-r border-warm-gray-200">
          {t('policy.assignments.title')}
        </TableHead>
        {headers.map((header) => (
          <TableHead key={header} className="border-r border-warm-gray-200">
            {header}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
};
